export default __webpack_public_path__ + "static/media/logo_sin_texto.882aff9c.png";